import { PortableTextBlock } from '@portabletext/react'
import { SanityButtonProps, SanityImage } from '~/types/sanity'
import { Button, ContentEditor, CustomIconCurve } from '~/components'

interface FeaturedContentProps {
  image: SanityImage
  showTopBanner: Boolean
  content: PortableTextBlock[]
  button: SanityButtonProps
}

export default function BlockFeaturedContent({
  image,
  showTopBanner,
  content,
  button,
}: FeaturedContentProps) {
  return (
    <div className="relative w-full overflow-hidden">
      {image && image.asset && image.asset.url && (
        <div className="relative">
          {showTopBanner && (
            <div className="absolute left-0 top-0 h-[5vh] w-full md:h-[10vh] lg:h-[15vh]">
              <CustomIconCurve className="h-full w-full" />
            </div>
          )}

          {content && (
            <div className="container absolute inset-0 flex items-center px-8 md:pl-20 md:pr-0">
              <div className="md:max-w-[40vw]">
                <ContentEditor content={content} />
                <div className="pt-8">
                  <Button
                    size="text-base"
                    {...button}
                  />
                </div>
              </div>
            </div>
          )}

          <img
            className="h-screen w-full object-cover object-[70%] md:object-[60%] lg:object-[50%]"
            src={image.asset.url}
            alt={image.alt}
          />
        </div>
      )}
    </div>
  )
}
